export const TOKEN_KEY = "@tknisfff";
export const BaseBackEND = ()=> "https://apipos.faculdadeolgamettig.edu.br/api/download/";


export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
};


export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};




// WEBPACK FOOTER //
// ./src/services/auth.js